import { Box } from '@mui/material';
import styles from './SelectAssigneeInput.module.scss';
import classNames from 'classnames/bind';
import { PlusIcon } from '~/assets/icons';
import BaseSelect from '~/components/common/base-select/BaseSelect';
import BaseImage from '~/components/common/base-image/BaseImage';
import { memo, useEffect, useState } from 'react';
import { ISelectAccount } from '~/utils/interface/account';

export type SelectAssigneeProps = {
  name?: string;
  options: Array<ISelectAccount>;
  value?: Array<string>;
  error?: string;
  helperText?: string;
  onChange?: (...event: any[]) => void;
  optionInput?: boolean;
};

const cx = classNames.bind(styles);

const SelectAssigneeInput = (props: SelectAssigneeProps) => {
  //#region Destructuring Props
  const { helperText, error, optionInput, ...restProps } = props;
  //#endregion Destructuring Props

  //#region Declare State
  const [value, setValue] = useState<Array<string>>([]);
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (props.value) setValue(props.value);
  }, [props.value]);
  //#endregion Implement Hook

  //#region Handle Function
  const renderSelectISelectAccountComponent = (item: ISelectAccount) => {
    return (
      <Box className='flex justify-center items-center gap-[10px] p-[6px_10px] w-full'>
        <Box>
          <BaseImage src={item.avatar} className='w-[30px] h-[30px] rounded-full object-contain' />
        </Box>
        <Box>
          <Box className='text-[#222732] text-[12px] leading-[14.4px] font-medium'>{item.name}</Box>
          <Box className='text-[#9AA4BA] text-[10px] leading-[12px]'>{item.email}</Box>
        </Box>
        <Box className='ml-auto'>
          <PlusIcon className='[&>path]:stroke-[#292D32] w-[10px] h-[10px]' />
        </Box>
      </Box>
    );
  };

  const renderSelectedInputOptionComponent = (item: ISelectAccount | Array<ISelectAccount>) => {
    if (Array.isArray(item)) return <></>;
    return (
      <Box className={cx('selected-assignee')}>
        {item ? (
          <Box className='flex items-center gap-[8px]'>
            <BaseImage src={item.avatar} className='w-[20px] h-[20px] rounded-full object-contain' />
            <Box className='text-[#5A6385] text-[14px]'>{item.name}</Box>
          </Box>
        ) : (
          <></>
        )}
      </Box>
    );
  };
  //#endregion Handle Function

  return (
    <>
      <BaseSelect
        {...restProps}
        onChange={(e) => {
          setValue(e.target.value);
          if (props.onChange) {
            props.onChange(e);
          }
        }}
        value={value}
        menuClassName={cx('select-assignee-menu')}
        className={cx('select-assignee')}
        options={props.options}
        renderSelected={(item: ISelectAccount | Array<ISelectAccount>) => renderSelectedInputOptionComponent(item)}
        renderOptionItem={(item: ISelectAccount) => renderSelectISelectAccountComponent(item)}
        multiple={optionInput ? false : true}
        isSearchEnable={true}
        helperText={helperText}
      />
    </>
  );
};

export default memo(SelectAssigneeInput) as typeof SelectAssigneeInput;
